import { AccountExpanded } from '@engine/models'

import { KeyValueDisplay, KeyValueItem } from '#components/KeyValueDisplay'

interface AccountDetailsProps {
  account: AccountExpanded
}

const AccountDetails = ({ account }: AccountDetailsProps) => {
  if (!account) {
    return <div>No account selected.</div>
  }

  const items: KeyValueItem[] = [
    {
      label: 'Account ID',
      value: account._id,
    },
    {
      label: 'Tenant ID',
      value: (
        <>
          {account.tenantName}{' '}
          <span className="text-xs opacity-60">{account.tenantId}</span>
        </>
      ),
    },
  ]

  if (account.address) {
    items.push({
      label: 'Address',
      value: account.address,
    })
  }

  if (account.address2) {
    items.push({
      label: 'Address 2',
      value: account.address2,
    })
  }

  if (account.city) {
    items.push({
      label: 'City',
      value: account.city,
    })
  }

  if (account.state) {
    items.push({
      label: 'State',
      value: account.state,
    })
  }

  if (account.postalCode) {
    items.push({
      label: 'Postal Code',
      value: account.postalCode,
    })
  }

  if (account.country) {
    items.push({
      label: 'Country',
      value: account.country,
    })
  }

  return (
    <div>
      <KeyValueDisplay items={items} />
    </div>
  )
}

export { AccountDetails }
